import { render, staticRenderFns } from "./CommercialTenantsWidget.vue?vue&type=template&id=12fe5886&scoped=true&"
import script from "./CommercialTenantsWidget.vue?vue&type=script&lang=js&"
export * from "./CommercialTenantsWidget.vue?vue&type=script&lang=js&"
import style0 from "./CommercialTenantsWidget.vue?vue&type=style&index=0&id=12fe5886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe5886",
  null
  
)

export default component.exports